import { createClassicHopFrames } from "../../core/hop-keyframes.js";

export const meta = Object.freeze({
  id: "hop",
  label: "Großer Hüpfer",
  duration: 1600,
  description: "Ein kräftiger Orbi-Hüpfer mit viel Höhe, deutlichem Squash und kleinem Rebound.",
  tags: ["body", "energetic", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const frames = createClassicHopFrames();
  const body = animate(elements.actor, frames.body, {
    duration: meta.duration,
    easing: "linear",
  });
  const shadow = animate(elements.shadow, frames.shadow, {
    duration: meta.duration,
    easing: "linear",
  });

  await Promise.allSettled([body.finished, shadow.finished]);
}
